// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1ilxI","inputWrap":"Table_inputWrap__35ADU","col":"Table_col__1d1c_","bmiTooltip":"Table_bmiTooltip__1H_PK"};